import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";
import { postImport } from "common/lib/importClient";

const api = new APIClient();

export const getCapacityAssessments = (params: any) =>
  api.get(url.GET_CAPACITY_ASSESSMENTS, params);
export const getCapacityAssessment = (id: any, params: any) => {
  const populate = [
    "conductedBy",
    "reportFile",
    "createdby",
    "createdby.agency",
    "updatedby",
    "agency",
    "overallRating",
    "typeOfAssessment",
    "contractor",
  ];
  if (!params?.populate) params.populate = populate;
  return api.get(url.GET_CAPACITY_ASSESSMENT + "/" + id, params);
};

export const addCapacityAssessment = (data: any) =>
  api.createAndUpload(url.ADD_CAPACITY_ASSESSMENT, data);
export const updateCapacityAssessment = (data: any) =>
  api.updateAndUpload(
    url.UPDATE_CAPACITY_ASSESSEMENT + "/" + data.id,
    data.formData
  );
export const deleteCapacityAssessment = (data: any) =>
  api.delete(url.DELETE_CAPACITY_ASSESSMENT + "/" + data.id, data);
export const importCapacityAssessments = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => {
  const controller = new AbortController();
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  if (options?.timeoutMs) {
    timeoutId = setTimeout(() => controller.abort(), options.timeoutMs);
  }

  return fetch(process.env.REACT_APP_API_URL + url.IMPORT_CAPACITY_ASSESSMENTS, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(data),
    signal: controller.signal,
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const metadata = response.headers.get("X-Metadata");
      let parsedMetadata = null;
      if (metadata) {
        try {
          parsedMetadata = JSON.parse(metadata);
        } catch (e) {
          parsedMetadata = metadata;
        }
      }

      const blob = await response.blob();
      return { blob, metadata: parsedMetadata };
    })
    .finally(() => {
      if (timeoutId !== null) clearTimeout(timeoutId);
    });
};
export const exportCapacityAssessmentsToCsv = (params: any) =>
  api.get(url.EXPORT_CAPACITY_ASSESSMENTS_TO_CSV, params);

// Capacity Assessment Ratings
export const getCapacityAssessmentRatings = (params: any) =>
  api.get(url.GET_CAPACITY_ASSESSMENT_RATINGS, params);
export const getCapacityAssessmentRating = (id: any, params: any) =>
  api.get(url.GET_CAPACITY_ASSESSMENT_RATING + "/" + id, params);
export const addCapacityAssessmentRating = (data: any) =>
  api.create(url.ADD_CAPACITY_ASSESSMENT_RATING, data);
export const updateCapacityAssessmentRating = (data: any) =>
  api.update(url.UPDATE_CAPACITY_ASSESSMENT_RATING + "/" + data.id, data);
export const deleteCapacityAssessmentRating = (id: any) =>
  api.delete(url.DELETE_CAPACITY_ASSESSMENT_RATING + "/" + id);
export const exportCapacityAssessmentRatingsToCSV = (params: any) =>
  api.get(url.EXPORT_CAPACITY_ASSESSMENT_RATINGS_TO_CSV, params, { responseType: "blob" });
export const importCapacityAssessmentRating = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => postImport(url.IMPORT_CAPACITY_ASSESSMENT_RATING, data, accessToken, options);

// Capacity Assessment Types
export const getCapacityAssessmentTypes = (params: any) =>
  api.get(url.GET_CAPACITY_ASSESSMENT_TYPES, params);
export const getCapacityAssessmentType = (id: any, params: any) =>
  api.get(url.GET_CAPACITY_ASSESSMENT_TYPE + "/" + id, params);
export const addCapacityAssessmentType = (data: any) =>
  api.create(url.ADD_CAPACITY_ASSESSMENT_TYPE, data);
export const updateCapacityAssessmentType = (data: any) =>
  api.update(url.UPDATE_CAPACITY_ASSESSMENT_TYPE + "/" + data.id, data);
export const deleteCapacityAssessmentType = (id: any) =>
  api.delete(url.DELETE_CAPACITY_ASSESSMENT_TYPE + "/" + id);
export const exportCapacityAssessmentTypesToCSV = (params: any) =>
  api.get(url.EXPORT_CAPACITY_ASSESSMENT_TYPES_TO_CSV, params, { responseType: "blob" });
export const importCapacityAssessmentType = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => postImport(url.IMPORT_CAPACITY_ASSESSMENT_TYPE, data, accessToken, options);
